<div class="ngx-address" [offClick]="onClose">
    <div class="ngx-address-title" [ngClass]="{'has':_t.title.length > 0}"
        (click)="onOpen()">
        <span [innerHTML]="_t.title ? _t.title : options.placeholder"></span>
        <i class="arrow"></i>
    </div>
    <div class="ngx-address-overlay" *ngIf="_t.inited" [hidden]="!_t.opened" [ngStyle]="{'top.px': options.offset.y,'left.px': options.offset.x}">
        <div class="ngx-address-select-warp">
            <div class="ngx-address-select-tab">
<!--                <a *ngFor="let item of _t.hd" [style.display]="(item.name === '国家') ? 'none': 'block'" (click)="onTabChange(item.index)" [ngClass]="{'current': item.selected}">{{item.name}}</a>-->
                <a *ngFor="let item of _t.hd" (click)="onTabChange(item.index)" [ngClass]="{'current': item.selected}">{{item.name}}</a>
            </div>
            <div class="ngx-address-select" *ngFor="let bitem of _t.bd" [hidden]="!bitem.selected">
                <dl *ngFor="let g of bitem.data.items | keys">
                    <dt *ngIf="g.key">{{g.key}}</dt>
                    <dd>
                        <a *ngFor="let i of g.value"
                            (click)="onItem(bitem.index, g.key, i.id, i)"
                            [ngClass]="{'current': i.selected}" title="{{i.name}}" data-id="{{i.id}}"
                            href="javascript:;">{{i.name}}</a>
                    </dd>
                </dl>
                <dl class="ngx-address-tips" *ngIf="bitem.data.tips && bitem.data.tips.length > 0">
                    <dd>
                        <p *ngFor="let ti of bitem.data.tips" data-id="{{ti.id}}">{{ti.name}}</p>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</div>